const checkArrayEmpty = (item) => {
	return Array.isArray(item) && item.length === 0;
};

export default checkArrayEmpty;
